import { useContext } from 'react';
import HelpWidget from '../HelpWidget/HelpWidget.jsx';
import { UserPreferencesContext } from '@contexts';

// wrapper around all columns
export const BodyWrapper = ({ children }) => {
  const [userPreferences, setUserPreferences] = useContext(
    UserPreferencesContext,
  );
  return (
    <>
      <div
        className={
          'sb-main ' + (userPreferences.hideSidebar ? 'sb-sidebar-hidden' : '')
        }
      >
        <div className="sb-flex">{children}</div>
      </div>
      <HelpWidget />
    </>
  );
};
